import { getToken } from '../../helpers/helpers';

export const getStationsPending = () => {
    return {
        type: 'GET_STATIONS_PENDING'
    }
};

export const getStationsSuccess = stations => {
    return {
        type: 'GET_STATIONS_SUCCESS',
        stations
    }
};

export const stationsError = error => {
    return {
        type: 'STATIONS_ERROR',
        error: error
    }
};

export const getStations = config => {
    const {search = '', page = 1, numberOnPage = 10} = config;
    const params = `number_on_page=${numberOnPage}${page ? '&page=' + page : ''}${search ? '&search=' + search : ''}`
    return dispatch => {
        dispatch(getStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/rimpro/weather_stations_list?${params}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(stationsError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .then(res => {
                dispatch(getStationsSuccess(
                    res.weatherStations
                ));
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectStation = station => {
    return {
        type: 'SELECT_STATION',
        selected: station
    };
};

export const addStationSuccess = () => {
    return {
        type: 'ADD_STATION_SUCCESS'
    }
};

export const addStation = stationData => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/rimpro/weather_station_create`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            },
            body: JSON.stringify(stationData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addStationSuccess());
                    dispatch(getStations({}));
                } else {
                    return res.json();
                }
            })
            .then(res => res ? dispatch(stationsError(`Error ${res.status}: ${res.message}`)) : null)
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const editStation = stationData => {

    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/rimpro/weather_station_update`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            },
            body: JSON.stringify(stationData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getStations({}));
                } else {
                    return res.json();
                }
            })
            .then(res => res ? dispatch(stationsError(`Error ${res.status}: ${res.message}`)) : null)
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteStation = id => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/rimpro/weather_station_delete/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getStations({}));
                    dispatch(selectStation({}));
                } else {
                    return res.json();
                }
            })
            .then(res => res ? dispatch(stationsError(`Error ${res.status}: ${res.message}`)) : null)
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
